// Тело раздела разбора: абзацы, списки, жирные фрагменты и рисунки.
//
// Жил внутри src/screens/Theory.tsx до 17 сентября 2026 и переехал сюда, когда
// у страницы появился второй зритель — редактор репетитора. Предпросмотр в
// редакторе обязан быть ТЕМ ЖЕ кодом, а не похожим: второй рендер той же
// разметки разошёлся бы с первым на первой правке, и взрослый правил бы
// вслепую, сверяя не то, что увидит ученик.
//
// Разбор текста на блоки — в src/lib/theory-blocks.ts, и он тоже один на обоих.

import { Formula } from "../lib/Formula";
import { blocksOf } from "../lib/theory-blocks";
import { Figure } from "./Figure";
import { NumberLine } from "./NumberLine";

export function TheoryBody({ source }: { source: string }) {
  return (
    <>
      {blocksOf(source).map((block, i) =>
        block.kind === "numline" ? (
          <NumberLine key={i} source={block.text} />
        ) : block.kind === "figure" ? (
          <Figure key={i} source={block.text} />
        ) : block.kind === "display" ? (
          // Абзац-формула: правило — в рамке, вычисление — на заливке. Чем
          // одно отличается от другого, решает src/lib/theory-blocks.ts.
          <div
            className={`theory__display theory__display--${block.vars ? "rule" : "value"}`}
            key={i}
          >
            <Formula source={block.tex} display />
          </div>
        ) : block.kind === "list" ? (
          <ul className="theory__list" key={i}>
            {block.items.map((item, n) => (
              <li key={n}>
                <Strong source={item} />
              </li>
            ))}
          </ul>
        ) : (
          <p className="theory__p" key={i}>
            <Strong source={block.text} />
          </p>
        ),
      )}
    </>
  );
}

/** `**жирный**` вокруг формул. Жирным в этих текстах помечено само правило. */
export function Strong({ source }: { source: string }) {
  const parts = source.split(/\*\*/);
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <strong key={i}>
            <Formula source={part} />
          </strong>
        ) : (
          <Formula key={i} source={part} />
        ),
      )}
    </>
  );
}
